import axios from "axios";

export const state = {
    clientInvoices: [],
    adminInvoices: []
};

export const mutations = {
    SET_INVOICES (state, {invoices, userType}) {
        invoices = invoices.map(invoice => {
            invoice.currency = invoice.client.client_profile.country.toLowerCase() === 'serbia' ? 'rsd' : 'eur';
            invoice.currencySymbol = invoice.client.client_profile.country.toLowerCase() === 'serbia' ? 'rsd' : '&euro;';

            return invoice;
        })
        state[`${userType}Invoices`] = invoices;
    },
    CLEAR (state) {
        state.clientInvoices = {};
    },
};

export const getters = {
    hasClientInvoices (state) {
        return state.clientInvoices.length
    },
    hasAdminInvoices (state) {
        return state.adminInvoices.length
    }
};

export const actions = {
    async getAdminInvoicesData({ commit }) {
        commit('loader/START_LOADING', null, { root: true });
        try{
            const { data } = await axios.get('/admin/invoice');
            commit('SET_INVOICES', {
                invoices: data,
                userType: 'admin'
            });
        } finally {
            commit('loader/END_LOADING', null, { root: true });
        }
    },
    async getClientInvoicesData({ commit }) {
        commit('loader/START_LOADING', null, { root: true });
        try{
            const { data } = await axios.get('/client/invoice');
            commit('SET_INVOICES', {
                invoices: data,
                userType: 'client'
            });
        } finally {
            commit('loader/END_LOADING', null, { root: true });
        }
    }
};
